<template>
  <div class="upload-detail">
    <div class="info-item title">{{ $t('shared.uploadSalesReceipt') }}</div>
    <div class="info-item person-info">
      <span class="user-name txt-ellipsis">{{ infoObj.nickname }}</span>
      <span class="user-type txt-ellipsis" v-if="infoObj.job">{{ infoObj.job }}</span>
    </div>
    <div class="info-item">{{ $t('shared.store') }}： <span class="store-name" @click="toUrl">{{ infoObj.customerName }}</span></div>
    <div class="info-item">{{ $t('shared.submissionTime') }}：{{ infoObj.localCreateTime }}</div>
    <div class="info-item img-content">
      <div>{{ $t('form.image') }}：</div>
      <div class="img-info item-img">
        <img v-for="(imgItem, imgIndex) in infoObj.imgUrl" :key="imgIndex" class="img-icon" :src="imgItem" alt="" @click="imgPreview(imgIndex)">
      </div>
    </div>
    <div class="info-item">{{ $t('shared.auditResult') }}：<span :style="`color: ${infoObj.statusColor}`">{{ infoObj.statusText }}</span></div>
    <div class="info-item" v-if="infoObj.status === -1">{{ $t('shared.reason') }}：{{ infoObj.failRemark }}</div>
    <div class="info-item" v-if="infoObj.orderType === 2">{{ $t('shared.sellOutProduct') }} {{ infoObj.totalQuantity }} {{ $t('form.pcs') }}，{{ $t('shared.earnedPoints', { totalIntegral: infoObj.totalIntegral }) }}</div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    imgPreview (index) {
      ImagePreview({
        images: this.infoObj.imgUrl,
        startPosition: index
      })
    },
    toUrl () {
      this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${this.infoObj.customerId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.upload-detail {
  flex: 1;
  padding: 28px 23px;
  font-size: 13px;
  .info-item {
    padding: 6px 0;
  }
  .store-name {
    color: #307bff;
    text-decoration: underline;
  }
  .person-info {
    display: flex;
    align-items: center;
    .user-name {
      max-width: 180px;
    }
    .user-type {
      max-width: 75px;
      padding: 2px 5px;
      text-align: center;
      border: 1px solid #307bff;
      color: #307bff;
      margin-left: 5px;
      font-size: 12px;
    }
  }
  .title {
    font-weight: bold;
  }
  .img-content {
    display: flex;
    .item-img {
      flex: 1;
    }
  }
  .img-icon {
    width: 48px;
    height: 48px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
